<template>
  <section class="quotes--quote-header">
    <fixed-header :title="pageTitle" :listPage="'/serviceorders'" hideNewOfferBtn>
      <template v-slot:center>
        <a class="mr-2">Contact</a>
        <div class="edit-contact-container mr-1">
          <edit-contact :companyId="serviceorder.companyId" :inlineButton="true" ref="editModal"
            @created="onContactCreated"></edit-contact>
        </div>
        <b-form-select class="w-auto mr-5" v-model="serviceorder.contactId">
          <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
            {{ select.firstName + ' ' + select.lastName }}</option>
        </b-form-select>
        <h6 class="mb-0 mr-2">Status:</h6>
        <a class="mr-5">{{ serviceorder.statusName }}</a>
        <a class="mr-2">Buyer</a>
        <b-form-select v-model="serviceorder.buyerUserId" class="w-auto mr-3">
          <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
            {{ selectRep.name }}
          </option>
        </b-form-select>
         <span v-if="serviceorder.dateShipped" class="ml-3">
          <h6 class="mb-0 mr-2">Shipped at:</h6>
          <a class="mr-2">{{ date(serviceorder.dateShipped) }}</a>
        </span>
        <span v-if="serviceorder.dateReceived" class="ml-3">
          <h6 class="mb-0 mr-2">Received at:</h6>
          <a class="mr-2">{{ date(serviceorder.dateReceived) }}</a>
        </span>
        <span v-if="serviceorder.isAuthorized" class="ml-3">
          <h6 class="mb-0 mr-2">Authorized by:</h6>
          <a class="mr-2"> {{serviceorder.authorizedByUserFullName}} on {{ date(serviceorder.dateAuthorized) }}</a>
        </span>
        <span v-if="serviceorder.dateSent" class="ml-3">
          <h6 class="mb-0 mr-2">Mailed at:</h6>
          <a class="mr-2">{{ date(serviceorder.dateSent) }}</a>
        </span>
        <span v-if="serviceorder.purchaseOrderId" class="ml-3">
          <h6 class="mb-0 mr-2">PO #:</h6>
          <a class="selector-link" @click="$router.push({ name: 'purchaseorders.edit',params: { id: serviceorder.purchaseOrderId }})">
            {{ serviceorder.purchaseOrderId }}
          </a>
        </span>
        <span v-if="serviceOrderLine.salesOrderId" class="ml-3">
          <h6 class="mb-0 mr-2">SO #:</h6>
          <a class="selector-link" @click="$router.push({ name: 'salesorders.edit',params: { id: serviceOrderLine.salesOrderId }})">
            {{ serviceOrderLine.salesOrderId }}
          </a>
        </span>
      </template>
    </fixed-header>

    <b-card class="quotes-header mb-1">
      <div class="d-flex">
        <address-selector
          @input="serviceorder.billingAddressId=$event.id, serviceorder.billingAddress=$event.newAddr"
          :value="serviceorder.billingAddress"
          :addressId="serviceorder.billingAddressId"
          title="Ship to"
          width="300"
          :accountId="serviceorder.companyId"
          class="mr-4"
        />
        <address-selector
          @input="serviceorder.shippingAddressId=$event.id, serviceorder.shippingAddress=$event.newAddr"
          :value="serviceorder.shippingAddress"
          :addressId="serviceorder.shippingAddressId"
          title="Ship From"
          width="300"
          :accountId="serviceorder.companyId"
          class="mr-4"
        />
        <div class="d-flex flex-column header-field-width mr-3">
          <!-- <b-form-group label-cols="4" label-align="right" label="SO #" label-size="lg" >
              <b-form-input v-model="serviceorder.id" disabled />
          </b-form-group> -->
          <b-form-group label-cols="4" label-align="right" label="SO Date" label-size="lg" >
              <b-form-input :value="date(serviceorder.soDate)" disabled />
          </b-form-group>
          <!-- <b-form-group label-cols="4" label-align="right" label="PO #" label-size="lg" >
              <b-form-input :value="serviceorder.purchaseOrderId" disabled />
          </b-form-group> -->
          <b-form-group label-cols="4" label-align="right" label="PO Date" label-size="lg" >
              <b-form-input :value="date(serviceorder.poDate)" disabled />
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="TH Quote #">
            <b-input-group size="sm">
              <b-form-input v-model="serviceorder.testHouseQuoteNumber" />
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Testing Status">
            <b-form-select v-model="lineStatusUpdate" @input="onChangeStatus">
              <option v-for="status in statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="d-flex flex-column header-field-width mr-3">
          <b-form-group label-cols="4" label-align="right" label="Ship Via" class="required">
            <b-form-select v-model="serviceorder.shippingProviderId" @change="onShippingAccountChange(true)" :class="{ 'is-invalid': $v.serviceorder.shippingProviderId.$error }">
              <option v-for="(select, index) in sortSelect(shippingProviders)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Method" :class="{ 'required': this.isRequiredShipDetails }">
            <b-form-select v-model="serviceorder.shippingMethodId" :class="{ 'is-invalid': $v.serviceorder.shippingMethodId.$error }">
              <option v-for="(select, index) in sortSelect(shipMethods)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship On" :class="{ 'required': this.isRequiredShipDetails }">
              <b-form-select v-model="serviceorder.alwaysShipBy" @change="onShippingAccountChange(false)" :class="{ 'is-invalid': $v.serviceorder.alwaysShipBy.$error }">
                <option value="0"></option>
                <option value="1">Vendor</option>
                <option value="2">House Account</option>
              </b-form-select>
          </b-form-group>
<!--          <b-form-group label-cols="4" label-align="right" label="Account">-->
<!--            <b-form-select v-model="serviceorder.companyId">-->
<!--              <option v-for="(select, index) in ['Vendor']" :key="index" :value="select.id">{{ select.name }}-->
<!--              </option>-->
<!--            </b-form-select>-->
<!--          </b-form-group>-->
          <b-form-group label-cols="4" label-align="right" label="Ship Acct #">
            <b-input-group size="sm">
              <b-form-input v-model="serviceorder.shippingAccountNumber" />
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Tracking #">
            <b-input-group size="sm">
              <b-form-input v-model="serviceorder.trackingNumber" />
              <b-input-group-append v-if="trackingLink">
                <b-button variant="primary" id="tooltip-button-not-interactive" @click="onNavigate">TRK</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="d-flex flex-column header-field-width mr-3" v-if="isPaid">
          <b-alert variant="success" class="mt-1 text-center" show size="sm"><strong>PAID</strong></b-alert>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapState,
} from 'vuex';
import moment from 'moment';
import {
  DATE_FORMAT,
} from '@/shared/constants';
//import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';

import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';
//import EditAddress from '@/pages/Company/components/CompanyDetails/tabs/Addresses/components/EditAddress/index';
import AddressSelector from '@/shared/components/AddressSelector/index';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import { date } from '@/shared/filters';
import { required, requiredIf, minValue } from 'vuelidate/lib/validators';
const isMinValue = function(val) { return this.isRequiredShipDetails ? val > 0 : val >= 0; }

export default {
  components: {
    EditContact,
    //EditAddress,
    AddressSelector,
    FixedHeader,
  },
  data() {
    return {
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      date,
      isSaving: false,
      statuses: [
        {id: 319, name: 'Open'},
        {id: 1488, name: 'Passed'},
        {id: 1489, name: 'Failed'},
      ],
      lineStatusUpdate: 0,
    }
  },
  watch: {
  },
  computed: {
    ...mapState('serviceOrders', [
      'serviceorder',
    ]),
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('shippingAccount', ['shippingAccountsList']),
    // ...mapState('quoteDetails', [
    //   'quotes',
    // ]),
    ...mapGetters('companies', ['companyById']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLineWithItems', 'serviceOrderLine']),
    ...mapGetters('lookup', ['shippingProviders', 'shipViaList', 'houseShippingAccounts']),
    ...mapGetters('quoteDetails', [
      // 'chargesById',
      // 'quoteById',
      'contacts',
      // 'quoteTerms',
      // 'quoteStatuses',
    ]),
    pageTitle() {
      return `    Work Orders: ${this.serviceOrderId} - ${this.serviceorder.companyName}`;
    },
    serviceOrderId() {
      return this.$route.params.id;
    },
    shipMethods() {
      if (this.serviceorder.shippingProviderId) {
        return this.shipViaList.filter(ship => ship.shippingProviderId == this.serviceorder.shippingProviderId);
      } else {
        return [];
      }
    },
    isPaid(){
      return (this.serviceorder.isPaid && this.serviceOrderLineWithItems.length > 0)
    },
    company() {
      var result = this.companyById(this.serviceorder.companyId);
      return result;
    },
    isRequiredShipDetails() {
      return (this.shippingProviders.length > 0 && this.serviceorder) ? this.shippingProviders.filter(prov => prov.name != "TBD" && prov.name != "Unassigned")
        .map(x => x.id).includes(this.serviceorder.shippingProviderId) : false;
    },
    trackingLink() {
      if (this.shippingProviders.length > 0 && this.serviceorder.shippingProviderId > 0 && this.serviceorder.trackingNumber != "" && this.serviceorder.trackingNumber != null) {
        let shipProvider = this.shippingProviders.find(x => x.id == this.serviceorder.shippingProviderId);
        if (shipProvider && shipProvider.trackingUrl != null) {
          let tempUrl = shipProvider.trackingUrl;
          let url = tempUrl.replace("{0}", this.serviceorder.trackingNumber);
          return url.startsWith("https://") ? url : "https://" + url;

        }
      } 
      
      return null;
    }
  },
  methods: {
    ...mapActions('serviceOrders', [ 'getById','authoriseServiceOrder' ]),
    ...mapActions('salesReps', ['getSalesReps']),
    ...mapActions('companies', { getCompanyById: 'getById' }),
    ...mapActions('quoteDetails', [
      'getQuoteTerms',
      'getContacts',
    ]),
    ...mapActions('shippingAccount', ['getShippingAccounts']),
    ...mapActions('serviceOrderLines', ['updateServiceOrderLine', 'getByServiceOrderId' ]),
    async onContactCreated(id) {
      await this.getContacts(this.serviceorder.companyId);
      //this.quote.contactId = id;
    },
   async authorizeServiceOrder() {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to authorize work order?  This action cannot be undone.'});
      if (deleteConfirmed) {
        try {
          this.isSaving = true;
          await this.authoriseServiceOrder(this.serviceOrderId);
          await this.getById(this.serviceOrderId);
          this.isSaving = false;
        }catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      }
    },
    onShippingAccountChange(isProviderChange = false) {
      if (isProviderChange) {
          let prov = this.shippingProviders.find(x => x.id == this.serviceorder.shippingProviderId);
          if (prov && prov.name == "TBD") {
            // auto set method if the provider is TBD
            let sMthd = this.shipViaList.find(x => x.shippingProviderId == this.serviceorder.shippingProviderId);
            this.serviceorder.shippingMethodId = (sMthd) ? sMthd.id : 0;
            
          } else {
            this.serviceorder.shippingMethodId = 0;
          }
      }
      let shipAccts = null;

      // If ship by is Vendor
      if (this.serviceorder.alwaysShipBy == 1) {
        shipAccts = this.shippingAccountsList.find(x => x.shippingProviderId == this.serviceorder.shippingProviderId);
      } else if (this.serviceorder.alwaysShipBy == 2) {
        shipAccts = this.houseShippingAccounts.find(x => x.shippingProviderId == this.serviceorder.shippingProviderId);
      }

      this.serviceorder.shippingAccountNumber = shipAccts != null ? shipAccts.accountNumber : null;
    },
    getHeaderValidation() {
      this.$v.$touch();
      this.$emit('header-validation', this.$v.$invalid);
    },
    onNavigate() {
      window.open(this.trackingLink, "_blank");
    },
    async onChangeStatus() {
      if (this.serviceOrderLine.statusId != this.lineStatusUpdate) {
        let stat = this.statuses.find(x => x.id == this.lineStatusUpdate);
        const confirmation = await this.openConfirmBox({
          message: `Are you sure you want to override the status to ${stat.name}?`,
          footerClass: 'p-2',
          hideHeaderClose: false,
        });
        this.onEditStatus= false;
        if (confirmation) {
          const result = await this.updateServiceOrderLine({...this.serviceOrderLine, statusId: this.lineStatusUpdate});
          if (result) {
            await this.getByServiceOrderId(result.serviceOrderId);
          }
        } else {
          this.lineStatusUpdate = this.serviceOrderLine.statusId
        }
      }
    },
  },
  watch: {
    'serviceorder.buyerUserId': {
      handler: function(newVal){
        this.$emit('onSalesRepChange', newVal);
      },
    },
    'serviceOrderLine.statusId': {
      handler: function() {
        this.lineStatusUpdate = this.serviceOrderLine.statusId;
      }
    }
  },
  validations: {
    serviceorder: {
      shippingProviderId: {required},
      shippingMethodId: { 
        required: requiredIf(function() { return this.isRequiredShipDetails }),
        isMinValue
      },
      alwaysShipBy: {
        required: requiredIf(function(){ return this.isRequiredShipDetails } ),
        isMinValue

      },
    }
  },
  async mounted() {
    this.setContainerLoader(true);
    // console.log(this.serviceOrderId, "Service Order id ")
    await this.getById(this.serviceOrderId).then(async () => {
      this.setContainerLoader(false);
      if (this.serviceorder.companyId) {
        this.getContacts(this.serviceorder.companyId);
        this.getShippingAccounts(this.serviceorder.companyId); 
        if (Object.keys(this.company).length == 0) {
          this.getCompanyById(this.serviceorder.companyId);
        }
        this.lineStatusUpdate = this.serviceOrderLine.statusId
      }
      this.getSalesReps();
      this.getQuoteTerms();
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'serviceorders'});
    });
  },
};

</script>

<style scoped>
.selector-link {
  color: #20a8d8 !important;
  font-size: 100%;
  font-weight: 700;
  padding-bottom: 1px;
}
.selector-link:hover {
  color: #167495 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
